module.exports = __webpack_public_path__ + "img/img_brand_cooperate_us@3x.618cbbc7.png";